import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { TaskList, TaskListCollection } from '../taskList/taskList.types';
import type { InspectionList, InspectionListCollection } from './inspectionList.types';

const useSelectedInspection = (inspectionId: string, fkSchedule: number) => {
  const getInspectionQuery = useCallback(
    (collection: InspectionListCollection) => collection?.find({ selector: { inspectionId } }),
    [inspectionId],
  );

  const getTaskQuery = useCallback(
    (collection: TaskListCollection) =>
      collection?.find({
        selector: { fkAssetInspection: Number(inspectionId), fkSchedule, isActive: { $eq: true } },
      }),
    [inspectionId, fkSchedule],
  );

  const { result: inspectionResult } = useRxData<InspectionList>(
    RxdbCollectionName.INSPECTION_LIST,
    getInspectionQuery,
    {
      json: true,
    },
  );

  const { result: taskResult } = useRxData<TaskList>(RxdbCollectionName.TASK_LIST, getTaskQuery, {
    json: true,
  });

  const selectedInspection = inspectionResult?.length
    ? {
        ...inspectionResult[0],
        taskList: taskResult.length ? taskResult : [],
      }
    : { assetId: '' };

  return { selectedInspection };
};

export default useSelectedInspection;
